

import Vue from 'vue'
import Router from './router'
import App from './App'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import Utils from './plugins/utils.js'
import Vbclass from 'vue-body-class'
import store from './store'
import VueProgressBar from 'vue-progressbar'

Vue.use(AjaxPlugin)
Vue.prototype.$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Vue.use(Utils)

const options = {
color: '#2c3e50',
failedColor: '#874b4b',
thickness: '5px',
transition: {
speed: '0.2s',
opacity: '0.6s',
termination: 300
},
autoRevert: true,
location: 'top',
inverse: false
}
Vue.use(VueProgressBar, options)

Vue.prototype.$http.interceptors.request.use(config => {
Vue.prototype.$Progress.start(); 
return config;
});
Vue.prototype.$http.interceptors.response.use(response => {
Vue.prototype.$Progress.finish(); 
return response;
});

const router = Router;
Vue.use(Vbclass, router)

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-main')



// WEBPACK FOOTER //
// ./src/main.js